import { cn } from '~shared/shadcn/lib/utils';
import { Checkbox } from '~shared/shadcn/ui/checkbox';

export interface Item {
  label: string;
  value: string;
}

interface SelectableItemProps {
  item: Item;
  isSelected: boolean;
  onToggle: () => void;
}

export function SelectableItem({
  item,
  isSelected,
  onToggle,
}: SelectableItemProps) {
  return (
    <div
      className={cn(
        'flex cursor-pointer items-center space-x-2 rounded-md p-2',
        isSelected ? 'bg-muted' : 'hover:bg-muted/50',
      )}
      onClick={onToggle}
    >
      <Checkbox
        checked={isSelected}
        onCheckedChange={() => {
          onToggle();
        }}
        id={`item-${item.value}`}
        className='pointer-events-none'
      />
      <label
        htmlFor={`item-${item.value}`}
        className='grow cursor-pointer text-sm'
      >
        {item.label}
      </label>
    </div>
  );
}
